<template>
    <div>
        <a
            href="#"
            style="color: green"
            @click="openHistory"
            title="Get change history"
        >
        {{name}}
        </a>
        <alteration-modal
            v-if="isModalVisible"
            @close="closeHistory"
            :title="`${name}`"
        >

            <template v-slot:body>
                <div v-if="isLoading"> Loading... </div>
                <div v-if="!isLoading && history && !error">
                    <div >
                        <table>
                            <thead>
                            <tr>
                                <th>Who</th>
                                <th>When</th>
                                <th>What</th>
                                <th>From</th>
                                <th>To</th>
                            </tr>
                            </thead>
                            <tbody>
                            <slot v-for="(alteration, indexA) in history">
                                <tr v-for="(field, index) in Object.keys(JSON.parse(alteration.new_value))"  :key="'field'+indexA+''+index">
                                    <td>{{ alteration.name }} {{alteration.last_name}}</td>
                                    <td>{{ alteration.created_at }}</td>
                                    <td>{{ field }}</td>
                                    <td v-html="JSON.parse(alteration.old_value)[field]"></td>
                                    <td v-html="JSON.parse(alteration.new_value)[field]"></td>
                                </tr>
                            </slot>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-if="!isLoading && !history && !error"> Nothing found</div>
                <div v-if="!isLoading && !history && error">
                    <p v-for="(field, index) in error" :key="index">
                        <b>{{ index }}:</b> - {{ field[0] }}
                    </p>
                </div>

            </template>

        </alteration-modal>
    </div>
</template>

<script>
export default {
    name: "HistoryFull",
    props: {
        name:       { type: String, required: true },
        subject_id: { type: Number, required: true },
        log_name:   { type: String, required: true }
    },
    data () {
      return {
          isModalVisible: false,
          isLoading: false,
          history: []
      }
    },
    methods: {
        closeHistory: function() {
            this.isModalVisible = false;
            this.history = null;
            this.isLoading = true;
        },
        formatText: function(text) {
            if(typeof(text) === 'string' && text == 'null') {
                return '';
            }

            if(text) {
                text = text.replace(/(\\r)*\\n/g, '<br/>').replace(/^"(.*)"$/, '$1');
            }

            return text;
        },
        openHistory: function() {
            this.isModalVisible = true;
            console.log(this);
            axios.post("/history/getHistoryFull", {
                log_name: this.log_name,
                subject_id: this.subject_id
            }).then(res => {
                this.isLoading = false;
                console.table = res.data[0];
                this.history = res.data[0];
            }).catch(err => {
                this.isLoading = false;
                this.error = err.response.data;
            });
        },
    }
}
</script>

<style  scoped>
.modal-backdrop {
     opacity: 1 !important;
}

tbody tr:nth-child(odd) {
    background: rgba(0,0,0,0.3);
}
table {
    min-width: 100%;
}
tbody td,
thead th {
    padding-left: 20px;
}
tbody td:first-child,
thead th:first-child {
    padding-left: 5px;
}
tbody td:last-child,
thead th:last-child {
    padding-right: 5px;
}
</style>
